export default "__VITE_ASSET__556bb17b__"